import React from 'react';
import { Text, Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './OnboardingChecklistFooter.messages.tsx';

const styles = cssMap({
	root: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		paddingBlock: token('space.150'),
		color: token('color.text.accent.purple'),
		zIndex: 100,
		backgroundColor: token('elevation.surface'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.050'),
		alignItems: 'center',
	},
});

export const OnboardingChecklistFooter = ({ children }: { children: React.ReactNode }) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.root}>
			{children}
			<Text color="color.text.subtlest" size="small">
				{formatMessage(messages.returnToItAnytime)}
			</Text>
		</Box>
	);
};
